export interface IAuthAccessToken {
  readonly Token: string;
  readonly Type: 'Bearer';
  readonly TenantSupportId: string;
  readonly TokenId: string;
  readonly PersonId: string;
  readonly TenantId: string;
}

export interface IAuthLoginPayload {
  Password: string;
  Email: string;
  Origin?: 'actuar' | 'facilfit';
}

export enum ELocalStorageKeys {
  auth = 'authorization',
  webauthn = 'credentials',
  rememberEmail = 'rememberEmail',
  allPersonsByUser = 'allPersonsByUser',
}

export type GetAllPersonsByUserResponse = {
  PersonId: string;
  UserId: string;
  FirstName: string;
  IsActive: boolean;
  IsOwner: boolean;
  AppSource: number;
  TenantId: string;
  TenantName: string;
  Email: string; //front end only
}
